import DinesSpinnerLogo from "@/components/Logos/DinesSpinnerLogo";
import Button from "../Buttons/Button";
import { ButtonType } from "@/types/library/Buttons";
import useLoader from "@/hooks/useLoader";

const DinesSpinner = () => {
  const { isLoading, loadingText, loadingActions, hideLoading } = useLoader();

  return (
    <>
      {isLoading && (
        <div className="fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-gray-100 opacity-90">
          <div className="flex flex-col items-center justify-center">
            <div className="animate-bounce self-center">
              <DinesSpinnerLogo />
            </div>
            {loadingText && (
              <span className="text-center font-bold text-lg">
                {loadingText}
              </span>
            )}
            <div className="flex items-center space-x-2">
              {loadingActions && (
                <div className="mx-auto flex items-center space-x-2">
                  {loadingActions.map(({ id, title, className, onAction }) => (
                    <button
                      type="button"
                      key={`loader-action-${id}`}
                      className={`rounded-lg px-4 py-2 font-bold ${className}`}
                      onClick={() => {
                        onAction();
                      }}
                    >
                      {title}
                    </button>
                  ))}
                </div>
              )}
              <Button
                text="Close"
                buttonType={ButtonType.Primary}
                onClick={() => hideLoading()}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DinesSpinner;
